import axios from 'axios'
import InviteUserModal from '~/components/modals/InviteUserModal'
import { isEmailAmongMembers, normalizeInviteEmail } from '~/lib/inviteMembers'

let nextTempId = 1

export default {
  data () {
    return {
      pendingInvites: []
    }
  },
  computed: {
    currState () {
      const d = JSON.parse(this.getSaveDataString())
      d.pendingInvites = this.pendingInvites
      return JSON.stringify(d)
    }
  },
  methods: {
    getInviteGroupId () {
      return null
    },
    getInviteMembers () {
      return []
    },
    getInviteContextLabel () {
      return ''
    },
    normalizeInviteEmail,
    queueInvite ({ email, name, startdate, enddate }) {
      const normalized = this.normalizeInviteEmail(email)
      if (!normalized || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
        return this.showError(this._('The email address is invalid.'))
      }
      const trimmedName = (name || '').trim()
      if (!trimmedName) {
        return this.showError(this._('Please enter a name.'))
      }
      const start = startdate || null
      const end = enddate || null
      if (start && end && end < start) {
        return this.showError(this._('The end date cannot be before the start date.'))
      }
      if (this.pendingInvites.some(i => this.normalizeInviteEmail(i.email) === normalized)) {
        return this.showError(this._('This email address has already been invited.'))
      }
      if (isEmailAmongMembers(normalized, this.getInviteMembers())) {
        return this.showError(this._('This user is already a member.'))
      }
      this.pendingInvites = [...this.pendingInvites, {
        tempId: nextTempId++,
        email: normalized,
        name: trimmedName,
        startdate: start,
        enddate: end
      }].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      this.showNotification(this._('Invitation queued for %s').replace('%s', normalized))
    },
    removePendingInvite (item) {
      this.pendingInvites = this.pendingInvites.filter(i => i.tempId !== item.tempId)
    },
    async flushPendingInvites (groupId) {
      if (!groupId || !this.pendingInvites.length) {
        return { sent: 0, failed: [], skipped: 0 }
      }
      const failed = []
      let sent = 0
      let skipped = 0
      const members = this.getInviteMembers()
      const toSend = [...this.pendingInvites]
      for (const invite of toSend) {
        if (isEmailAmongMembers(invite.email, members)) {
          this.pendingInvites = this.pendingInvites.filter(i => i.tempId !== invite.tempId)
          skipped++
          continue
        }
        try {
          const response = await axios.post(
            this.baseDomain + this.shopId + '/userinvitations.json?apikey=' + this.apiKey,
            {
              email: invite.email,
              name: invite.name,
              groupIds: [parseInt(groupId)],
              locale: this.locale,
              startdate: invite.startdate || null,
              enddate: invite.enddate || null
            }
          )
          sent++
          this.pendingInvites = this.pendingInvites.filter(i => i.tempId !== invite.tempId)
          if (response.data && response.data.added && this.EventBus) {
            this.EventBus.$emit('collectionUsersChanged')
          }
        } catch (e) {
          failed.push(invite)
        }
      }
      if (failed.length) {
        this.showError(this._('%d invitation(s) could not be sent').replace('%d', String(failed.length)))
      }
      return { sent, failed, skipped }
    },
    inviteMember () {
      const groupId = this.getInviteGroupId()
      const memberEmails = (this.getInviteMembers() || [])
        .map(m => m.email)
        .filter(Boolean)
      this.showModal('invite-member', InviteUserModal, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          locale: this.locale,
          advancedCollections: this.$store.getters.advancedCollections ? 1 : 0,
          groupsUrl: this.baseDomain + this.shopId + '/usergroups.json?apikey=' + this.apiKey,
          presetGroupIds: groupId ? [groupId] : [],
          queueOnly: !groupId,
          contextLabel: this.getInviteContextLabel(),
          hideGroupSelector: true,
          memberEmails
        },
        width: 560,
        backgroundEvents: {
          queued: (invite) => this.queueInvite(invite)
        }
      })
    }
  }
}
